import React from 'react';
import Text from 'components/form/field/Text';

const Number = (props) => {
    return <Text { ...props } inputType="number" allowedAttributes={ ['min', 'max'] }/>
};

export default Number;